import React from "react";
import { Star } from "@phosphor-icons/react";

/** Feedback display (when submitted) or rating form (when not). */
export function JobFeedbackCard({ job, rating, setRating, comments, setComments, busy, onSubmit }) {
  return (
    <div className="rmms-card p-5">
      <div className="overline mb-3"><Star size={11} className="inline -mt-0.5" /> Feedback</div>
      {job.feedback ? (
        <div>
          <div className="flex items-center gap-1">
            {[1, 2, 3, 4, 5].map(n => (
              <Star key={n} size={20} weight={n <= job.feedback.rating ? "fill" : "regular"} color={n <= job.feedback.rating ? "#F59E0B" : "#CBD5E1"} />
            ))}
            <span className="ml-2 font-mono-data text-sm">{job.feedback.rating}/5</span>
          </div>
          {job.feedback.comments && <p className="text-sm text-slate-600 mt-2">"{job.feedback.comments}"</p>}
        </div>
      ) : (
        <div className="flex flex-wrap items-end gap-3">
          <div>
            <label className="overline mb-1.5 block">Your rating</label>
            <div className="flex items-center gap-1">
              {[1, 2, 3, 4, 5].map(n => (
                <button key={n} data-testid={`feedback-star-${n}`} onClick={() => setRating(n)} type="button">
                  <Star size={22} weight={n <= rating ? "fill" : "regular"} color={n <= rating ? "#F59E0B" : "#CBD5E1"} />
                </button>
              ))}
            </div>
          </div>
          <input value={comments} onChange={e => setComments(e.target.value)} data-testid="feedback-comments-input" placeholder="Comments…" className="rmms-input flex-1 min-w-[200px]" />
          <button onClick={onSubmit} disabled={busy} data-testid="feedback-submit-button" className="h-10 px-4 rounded-md text-white text-sm font-medium" style={{ background: "#002FA7" }}>Submit</button>
        </div>
      )}
    </div>
  );
}
